// ══════════════ BANNIÈRE D'AIDE GÉOLOCALISATION ══════════════
// Extrait de GerantClientUI.jsx (refacto étape A — briques terrain, 07/07/2026).
// Brique partagée utilisée par GerantUI et StaffUI.
// Feuille : aucune dépendance vers un composant interne de GerantClientUI.
// Détecte les pointages récents (7 derniers jours) où la géolocalisation a été refusée
// et affiche les instructions pour la réactiver selon la plateforme.
import React, { useState } from 'react';

export function GeoHelpBanner({sid,tc,als}){
  const[dismissed,setDismissed]=useState(false);
  const cutoff=new Date();cutoff.setDate(cutoff.getDate()-7);
  // Logique : la bannière s'affiche uniquement si le DERNIER pointage géolocalisable
  // (als ou tc) du salarié dans les 7 derniers jours a échoué.
  // Si la géoloc fonctionne à nouveau (dernier pointage OK), on n'alerte plus.

  // Pointages d'appartement (als) du salarié dans les 7 derniers jours, triés du + récent au + ancien
  const recentAls=(als||[])
    .filter(l=>l.sid===sid&&l.ts&&new Date(l.ts)>cutoff)
    .sort((a,b)=>new Date(b.ts)-new Date(a.ts));
  // Dernier als : a-t-il échoué ?
  const lastAlsFailed=recentAls.length>0&&!!recentAls[0].geoErr;

  // Pour les pointages journaliers (tc), on regarde le dernier sous-événement (sw/breaks/ew)
  // chronologiquement. S'il a échoué côté géo, on alerte.
  let lastTcEvent=null,lastTcTs=null;
  (tc||[]).forEach(c=>{
    if(c.sid!==sid||!c.date)return;
    const d=new Date(c.date);if(d<cutoff)return;
    // Reconstituer tous les sous-événements de ce pointage avec leur ts
    const events=[];
    if(c.sw?.ts)events.push({ts:c.sw.ts,failed:!!c.sw.geoErr});
    if(c.ew?.ts)events.push({ts:c.ew.ts,failed:!!c.ew.geoErr});
    if(Array.isArray(c.breaks))c.breaks.forEach(b=>{
      if(b?.start)events.push({ts:b.start,failed:!!b.geoErr});
      if(b?.end)events.push({ts:b.end,failed:!!b.geoErrEnd});
    });
    events.forEach(ev=>{
      if(!lastTcTs||new Date(ev.ts)>new Date(lastTcTs)){lastTcTs=ev.ts;lastTcEvent=ev;}
    });
  });
  const lastTcFailed=!!(lastTcEvent&&lastTcEvent.failed);

  // On affiche la bannière uniquement si le dernier événement géolocalisable (als OU tc)
  // a échoué. Si l'un des deux flux récents est OK, on considère que ça remarche.
  if(!lastAlsFailed&&!lastTcFailed)return null;
  if(dismissed)return null;
  return(<div style={{background:'#fff4d6',border:'2px solid #e5c977',borderRadius:12,padding:'14px 18px',marginBottom:14,display:'flex',gap:14,flexWrap:'wrap',alignItems:'flex-start'}}>
    <div style={{fontSize:32,lineHeight:1}}>📍</div>
    <div style={{flex:1,minWidth:240}}>
      <div className="D" style={{fontSize:15,color:'#7a5a00',marginBottom:4}}>Géolocalisation refusée sur tes derniers pointages</div>
      <div style={{fontSize:12,color:'#7a5a00',marginBottom:10,lineHeight:1.4}}>Tes pointages doivent être géolocalisés pour valider ta présence sur place. Voici comment réactiver la position sur ton téléphone :</div>
      <details style={{fontSize:12,color:'#7a5a00',marginBottom:6}}><summary style={{cursor:'pointer',fontWeight:700,padding:'4px 0'}}>📱 iPhone (Safari)</summary>
        <ol style={{paddingLeft:20,marginTop:6,lineHeight:1.5}}>
          <li>Réglages → Confidentialité et sécurité → Service de localisation → vérifier qu'il est <strong>activé</strong></li>
          <li>Dans la même page, taper sur <strong>Safari</strong> → choisir <strong>« Lors de l'utilisation »</strong></li>
          <li>Revenir dans l'app et recharger la page (tirer vers le bas)</li>
          <li>Au prochain pointage, accepter le popup « autoriser la position »</li>
        </ol>
      </details>
      <details style={{fontSize:12,color:'#7a5a00',marginBottom:6}}><summary style={{cursor:'pointer',fontWeight:700,padding:'4px 0'}}>📱 Android (Chrome)</summary>
        <ol style={{paddingLeft:20,marginTop:6,lineHeight:1.5}}>
          <li>Dans Chrome, taper sur le <strong>cadenas</strong> à gauche de l'adresse → Autorisations → Localisation → <strong>Autoriser</strong></li>
          <li>Si rien ne s'affiche : Paramètres téléphone → Applications → Chrome → Autorisations → Localisation → <strong>Autoriser</strong></li>
          <li>Revenir dans l'app et recharger</li>
        </ol>
      </details>
      <details style={{fontSize:12,color:'#7a5a00'}}><summary style={{cursor:'pointer',fontWeight:700,padding:'4px 0'}}>💻 Ordinateur</summary>
        <ol style={{paddingLeft:20,marginTop:6,lineHeight:1.5}}>
          <li>Cliquer sur l'icône à gauche de l'adresse (cadenas ou ⓘ)</li>
          <li>Trouver « Localisation » → choisir <strong>Autoriser</strong></li>
          <li>Recharger la page (Cmd/Ctrl + R)</li>
        </ol>
      </details>
      <div style={{fontSize:11,color:'#7a5a00',marginTop:10,fontStyle:'italic'}}>Si ça ne fonctionne toujours pas, préviens la direction.</div>
    </div>
    <button onClick={()=>setDismissed(true)} className="btn bgh sm" style={{alignSelf:'flex-start',fontSize:11}} title="Masquer jusqu'au prochain chargement de la page">✕ Masquer</button>
  </div>);
}
